import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import { DialogActions, DialogContent } from '@material-ui/core'
import styled from 'styled-components'

export const CustomDialogActions = styled(DialogActions)`
  display: flex;
  justify-content: center;
  padding-bottom: 42px;
`

export const CustomDialogContent = styled(DialogContent)`
  padding: 0;
  border-top: none;

  &:first-child {
    padding: 0 !important;
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 150px;
  padding: 42px 24px 26px;
  text-align: center;
  position: relative;
`

export const Title = styled.h3`
  color: ${({ theme }) => theme.colors.grayscale.black};
  font-style: italic;
`

export const Text = styled.p`
  color: ${({ theme }) => theme.colors.grayscale.black};
  margin: 20px 0 10px;
`

export const TimeoutText = styled.p`
  color: ${({ theme }) => theme.colors.grayscale.black};
  font-weight: 500;
  margin: 0;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
`

export const Button = styled(PrimaryButton)`
  max-width: 260px;
  text-transform: initial;
`

export const CloseButton = styled.button`
  border: none;
  background: none;
  position: absolute;
  right: 15px;
  top: 15px;
  padding: 5px;
  cursor: pointer;
`
